import { interval } from 'rxjs';
import { startWith } from 'rxjs/operators';

import request from '@utils/axiosWrapper';
import setParams, { NewSetParams } from '@utils/set';

const POLLING_INTERVAL = 60 * 60 * 1000;

/** set化参数轮询 */
const init = () => {
    interval(POLLING_INTERVAL)
        .pipe(startWith(0))
        .subscribe(() => {
            request.get<NewSetParams>('/v2/common/r/getRegionId').then(res => {
                setParams.setParams(res);
            });
        });
};

export default { init };
